var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGym(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 3)",
    fill: "#666",
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.692 9.625l-2.608 1.087a.25.25 0 01-.338-.167l-1.15-4.37a.25.25 0 00-.241-.186H4.1a.25.25 0 00-.236.169l-1.948 5.665a1.248 1.248 0 001.18 1.653H6.24a.25.25 0 01.195.094l1.996 2.495a.25.25 0 01-.39.312L6.12 13.975H3.096a1.747 1.747 0 01-1.652-2.315l1.948-5.665A.749.749 0 014.1 5.49h1.255c.34 0 .637.23.724.558l1.077 4.093 2.371-.988a1.996 1.996 0 11.165.472zm1.788.607a1.497 1.497 0 100-2.995 1.497 1.497 0 000 2.995zm-5.49-6.24A1.996 1.996 0 115.99 0a1.996 1.996 0 010 3.993zm0-.498a1.497 1.497 0 100-2.995 1.497 1.497 0 000 2.995zM.25 16.47a.25.25 0 110-.5h5.24a.25.25 0 110 .5H.25z",
    strokeWidth: 0.4,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 8.5,
    r: 1.5
  })))));
}
export default SvgGym;